import { render, staticRenderFns } from "./fixeauModule.vue?vue&type=template&id=83540baa&scoped=true&"
import script from "./fixeauModule.vue?vue&type=script&lang=js&"
export * from "./fixeauModule.vue?vue&type=script&lang=js&"
import style0 from "./fixeauModule.vue?vue&type=style&index=0&id=83540baa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83540baa",
  null
  
)

export default component.exports